import * as Highcharts from 'highcharts';

export interface CustomLegendItem {
    name: string;
    color?: string;
    visible?: boolean;
    symbol?: string;
}

export interface CustomLegendOptions extends Highcharts.LegendOptions {
    items?: CustomLegendItem[];
}


export interface ReportSummaryItem {
    label: string;
    value: string | number;
    unit?: string;
    seriesName?: string;
}

export interface SiteDataItem {
    name: string;
    id?: number;
    data: Array<[number, number]> | Array<Highcharts.PointOptionsObject>;
    color?: string;
    type?: string;
}

export type HydroGraphDataPoint = [number, number] | [number, number | null] | Highcharts.PointOptionsObject;

export class ChartLegend {
    public enabled: boolean;
    public layout: string;
    public align: string;
    public verticalAlign: string;
    public title: string;
    constructor() {
        this.enabled = true;
        this.layout = 'horizontal';
        this.align = 'right';
        this.verticalAlign = 'bottom';
        this.title = '';
    }
}

export interface HydroGraph {
    series: Array<string>;
    data: Array<HydroGraphDataPoint>;
    reportSummary?: Array<ReportSummaryItem>;
    siteData?: Array<SiteDataItem>;
}

export class ChartProperty {
    public chartId: string | number;
    public chartTitle = '';
    public chartType?: string;
    public chartEvents?: Highcharts.ChartEventsOptions = {};
    public chartLegend?: ChartLegend = new ChartLegend();
    public showZoom = true;
    public showRangeSelector?: boolean;
    public showCredits = false;
    public chartXAxis: Highcharts.XAxisOptions | Highcharts.XAxisOptions[];
    public chartYAxis: Highcharts.YAxisOptions | Highcharts.YAxisOptions[];
    public chartRangeSelectorOption?: Highcharts.RangeSelectorOptions;
    public chartToolTipOption: Highcharts.TooltipOptions;
    public chartSeriesData?: Highcharts.SeriesOptionsType[];
    public chartPlotOptions: Highcharts.PlotOptions;
    public enableExport = false;
    public showNavigator = true;
    public showCustomLegend = false;
    public chartCustomLegend: CustomLegendOptions;
    public chartScrollBarOptions?: Highcharts.ScrollbarOptions;
    constructor() {
        this.showRangeSelector = false;
        this.chartType = 'line';
    }
}
